import { useEffect, useState } from "react";

/**
 * Bir değerin GECİKMELİ kopyası — hızlı değişen girdiyi (arama kutusu) ağ isteğine
 * çevirmeden önce dinlendirir.
 *
 * NEDEN VAR: Siparişler ekranında arama kutusu hem listeyi hem süzgeç özetini besliyor.
 * Özet uç başına birkaç toplama sorgusu çalıştırdığı için, her tuş vuruşunda yeni bir
 * sorgu anahtarı üretmek "tortilla" yazarken 8 tur istek doğuruyordu; ekrandaki KPI
 * bloğu da her turda yükleniyor durumuna düşüp yerleşimi zıplatıyordu.
 *
 * ⚠ AYNA: gecikmeli değeri süzgecin YALNIZ bir tüketicisine vermek, liste ile özetin
 * geçici olarak FARKLI soruları yanıtlamasına yol açar. Aynı soruyu soran tüm sorgular
 * aynı gecikmeli değeri kullanmalıdır.
 */
export function useDebounced<T>(deger: T, gecikmeMs = 300): T {
  const [gecikmeli, setGecikmeli] = useState(deger);
  useEffect(() => {
    const t = setTimeout(() => setGecikmeli(deger), gecikmeMs);
    return () => clearTimeout(t);
  }, [deger, gecikmeMs]);
  return gecikmeli;
}
